import { FormSectionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/_shared/FormSectionWrapper';
import {
  FamiliarSituationForm as FamiliarSituation,
  FamiliarSituationFormProps,
} from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/FamiliarSituation/components/FamiliarSituationForm';

export const FamiliarSituationForm = ({ fieldVariant, fullWidth, direction }: FamiliarSituationFormProps) => {
  return (
    <FormSectionWrapper titleTid="FAMILIAR_SITUATION">
      <FamiliarSituation fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction} />
    </FormSectionWrapper>
  );
};
